import FilterList from '@/components/content/FilterList'
import Input from '@/components/content/Input'
import DateRangePickerInput from '@/components/date/DateRangePickerInput'
import MenuCodeSelectModal from '@/components/system/MenuCodeSelectModal'
import SearchInput from '@/components/system/SearchInput'
import { HistoryUserLogReqParams } from '@/services/history/history.types'
import { DATE_FORMAT } from '@/utils/consts'
import dayjs from 'dayjs'
import { useFormContext } from 'react-hook-form'

export const defaultValues: HistoryUserLogReqParams = {
  email: '',
  evtDate: [dayjs().format(DATE_FORMAT.dateSimple), dayjs().format(DATE_FORMAT.dateSimple)],
  menuCd: '',
}

interface UserLogFormProps {
  onSearch(values: HistoryUserLogReqParams): void
}
export const UserLogForm = ({ onSearch }: UserLogFormProps) => {
  const { setValue, watch, reset, handleSubmit } = useFormContext<HistoryUserLogReqParams>()
  const values = watch()

  return (
    <FilterList
      list={[
        [
          {
            label: '유저 ID',
            value: <Input value={values.email} onChange={(v) => setValue('email', v)} />,
          },
          {
            label: '사용일자',
            value: (
              <DateRangePickerInput
                value={values.evtDate}
                onChange={(v) => {
                  const [start, end] = v
                  setValue('evtDate', [
                    start ? dayjs(start).format(DATE_FORMAT.dateSimple) : '',
                    end ? dayjs(end).format(DATE_FORMAT.dateSimple) : '',
                  ])
                }}
              />
            ),
            required: true,
          },
          {
            label: '메뉴코드',
            value: (
              <MenuCodeSelectModal
                trigger={<SearchInput value={values.menuCd} onChange={(v) => setValue('menuCd', v)} />}
                onSelect={({ menuCode }) => setValue('menuCd', menuCode)}
              />
            ),
          },
        ],
      ]}
      onReset={() => reset(defaultValues)}
      onSearch={handleSubmit(onSearch)}
    />
  )
}
